import { render, staticRenderFns } from "./MailboxLayout.vue?vue&type=template&id=36f29194&scoped=true&"
import script from "./MailboxLayout.vue?vue&type=script&lang=ts&"
export * from "./MailboxLayout.vue?vue&type=script&lang=ts&"
import style0 from "./MailboxLayout.vue?vue&type=style&index=0&id=36f29194&prod&lang=scss&"
import style1 from "./MailboxLayout.vue?vue&type=style&index=1&id=36f29194&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f29194",
  null
  
)

export default component.exports